export default "__VITE_ASSET__D$_5_uzA__"